import * as React from "react";
import Loader from "../../../components/atoms/Loader";
import KarteItem from "../../../components/features/KarteItem";
import StudentFilter from "../../../components/features/NewStudentFilter";
import TabsNavi from "../../../components/molecules/TabsNavi";
import KarteInterface from "../../../interfaces/KarteInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import styles from "./styles.scss";

interface Props {
  section: SectionInterface;
  kartes: KarteInterface[];
  isLoading: boolean;
}

const renderKartes = (props: Props) => {
  const { section, kartes } = props;

  if (kartes.length === 0) {
    return <p className={styles.notfound}>カルテがありません</p>;
  }

  return kartes.map((karte) => {
    return (
      <KarteItem
        section={section}
        karte={karte}
        key={`SectionKartes-KarteItem-${karte.id}`}
      />
    );
  });
};

const SectionsKartes = (props: Props) => {
  return (
    <React.Fragment>
      <TabsNavi
        tabs={[
          {
            label: "カルテ",
            link: `/sections/${props.section.id}/kartes`,
            active: true,
          },
        ]}
      />
      <StudentFilter sectionId={props.section.id} />
      {renderKartes(props)}
      <Loader loading={props.isLoading} />
    </React.Fragment>
  );
};

export default SectionsKartes;
